var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.quickfinder},[_c('QuickfinderFlyout',{attrs:{"list-items":_vm.listItems},on:_vm._d({},[_vm.toogleMenu,_vm.setActiveState])},[_c('QuickfinderButton',{attrs:{"is-active":_vm.isActive}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }